import { createAction } from 'redux-actions';

export const getCoLiving = createAction('GET_COLIVING', items => {
	const data = {};
	const list = items.map(item => {
		data[item.id] = {
			apartmentId: item.apartment_id,
			apartmentName: '',
			content: item.content,
			id: item.id,
			position: item.position,
			url: item.url_url,
			title: item.title,
			createdAt: item.created_at,
		};

		return item.id;
	});

	return { list, data };
});



// WEBPACK FOOTER //
// ./src/actions/coLiving.js